import { parse } from 'tldts';

export const getSubdomainFromUrl = (value) => {
    if (!value) {
        return '';
    }

    const input = value instanceof URL ? value.href : String(value);
    const { subdomain } = parse(input);

    return subdomain || '';
};

export const checkIsDukePNGPortalSubdomain = (subdomain) => {
    const normalizedSubdomain = String(subdomain || '').toLowerCase();
    const dukeSubdomains = (process.env.REACT_APP_DUKE_PORTAL_SUBDOMAINS || '')
        .split(',')
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean);
    const pngSubdomains = (process.env.REACT_APP_PNG_PORTAL_SUBDOMAINS || '')
        .split(',')
        .map((value) => value.trim().toLowerCase())
        .filter(Boolean);

    if (dukeSubdomains.includes(normalizedSubdomain)) {
        return 'Duke';
    } else if (pngSubdomains.includes(normalizedSubdomain)) {
        return 'PNG';
    } else {
        return null;
    }
};